import { PropFormikField } from "constant/prop-types";
import { ErrorMessage } from "formik";
import isEmpty from "lodash/isEmpty";
import noop from "lodash/noop";
import PropTypes from "prop-types";
import React from "react";
import { FormGroup, FormText } from "react-bootstrap";
import { List } from "ui/list";
import ParamUtils, { PRIORITY } from "ui/parameter-form/utils";

import { CustomParamField } from "./custom-param-field";
import Overrides from "./overrides";

class CustomParamFormField extends React.PureComponent {
  static get propTypes() {
    return {
      field: PropFormikField.isRequired,
      form: PropTypes.object.isRequired,
      legacyParams: PropTypes.instanceOf(Set),
      network: PropTypes.object.isRequired,
      networkParams: PropTypes.arrayOf(PropTypes.object).isRequired,
      onOverride: PropTypes.func,
      onRemove: PropTypes.func,
      priority: PropTypes.oneOf([PRIORITY.DEVICE, PRIORITY.NETWORK]).isRequired,
      readOnly: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      onOverride: noop,
      readOnly: false,
    };
  }

  constructor(props) {
    super(props);

    const { field } = props;
    const { hasOverride, isOverriding } = field.value;

    if (hasOverride) {
      props.onOverride(field, isOverriding);
    }

    this._hasDuplicate = this._hasDuplicate.bind(this);
  }

  _handleChange(name, value) {
    this.props.form.setFieldValue(name, value);
  }

  _hasDuplicate(key) {
    // Empty key field is not a duplicate, we'll exclude empty field
    // on submission.
    if (!key) {
      return false;
    }

    const { form } = this.props;
    const uniqueKeys = new Set(
      Object.values(form.values.params)
        .filter(({ isDuplicate }) => !isDuplicate)
        .map(({ k }) => k),
    );

    return uniqueKeys.has(key);
  }

  render() {
    const {
      field,
      legacyParams,
      network,
      networkParams,
      onOverride,
      onRemove,
      priority,
      readOnly,
    } = this.props;
    const { k, errors, hasOverride, isOverriding } = field.value;
    const handleChange = this._handleChange.bind(this, field.name);
    const hasNetworkLevel = ParamUtils.hasNetworkLevelParam(k, networkParams);
    const hasErrors = (errors || []).length > 0;

    return (
      <FormGroup className={!isEmpty(errors) ? "has-error" : ""}>
        <CustomParamField
          field={field}
          hasDuplicate={this._hasDuplicate}
          handleChange={handleChange}
          legacyParams={legacyParams}
          onRemove={onRemove}
          readOnly={readOnly}
        />
        {hasOverride && (
          <Overrides.Toggle
            defaultValue={isOverriding}
            onChange={(value) => onOverride(field, value)}
          >
            <Overrides.Label
              networkId={network.id}
              priority={priority}
              hasDefaultValue={false}
              hasNetworkLevel={hasNetworkLevel}
            />
          </Overrides.Toggle>
        )}
        <ErrorMessage name={field.name} component="div" />
        {hasErrors && (
          <FormText>
            <List className="list-compact" items={errors} />
          </FormText>
        )}
      </FormGroup>
    );
  }
}

export { CustomParamFormField };
